import React from 'react'
import cn from 'classnames'
import type {ComponentPropsWithClass} from '../helpers/react-helpers'
import {toBool} from '../kb'
import {TestIdConsumer} from '../contexts/testid'

interface CheckboxProps extends ComponentPropsWithClass<'input'> {
    indeterminate?: boolean
    testId?: string
}

export default class Checkbox extends React.Component<CheckboxProps> {
    private el: HTMLInputElement | null = null

    componentDidMount() {
        if(this.el && this.props.indeterminate != null) {
            this.el.indeterminate = toBool(this.props.indeterminate, true)
        }
    }

    componentDidUpdate(prevProps: CheckboxProps, prevState: never) {
        if(this.el && prevProps.indeterminate !== this.props.indeterminate) {
            this.el.indeterminate = toBool(this.props.indeterminate, true)
        }
    }

    render() {
        const {indeterminate, checked, className, testId, ...attrs} = this.props
        if(checked != null) {
            (attrs as React.ComponentProps<'input'>).checked = toBool(checked, true)
        }
        return (
            <TestIdConsumer id={testId}>{testId => (
                <label className={cn('toggleSwitch', className)}>
                    <input data-testid={testId} ref={el => {
                        this.el = el
                    }} type="checkbox" {...attrs} className="ts_input"/>
                    <span className="ts_slider"/>
                </label>
            )}</TestIdConsumer>
        )
    }
}

